export enum FilesTypes {
   img_document = "image/jpeg, image/png, image/jpg, application/pdf",
   img_only = "image/jpeg, image/png, image/jpg",
   document_only = "application/pdf",
   img_document_json = "image/jpeg, image/png, image/jpg, application/pdf, application/json",
}
